export default "__VITE_PUBLIC_ASSET__8be1f493__"